import RMSPortfolioAnalyseDataContainer from "./RMSPortfolioAnalyseDataContainer";
import RMSPortfolioAnalyseDataStore from "./RMSPortfolioAnalyseDataStore";


export default RMSPortfolioAnalyseDataStore(RMSPortfolioAnalyseDataContainer);